import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/74c1561e-f340-4a46-945f-d312ea9e94f8";
export const REGISTER_URL = "https://a.ntrk2.com/5ee7b6c9-8fb3-4836-91af-2994e5554831";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://popbr.loadprkw2a.com/download?openExternalBrowser=1&id=n3ea2ej2y8xqohv";

export * from "./codes";
export * from "./context";
